import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';
import { BsModalAlertComponent } from './modal-alert.component';
import { BsModalConfirmComponent } from './modal-confirm.component';

@NgModule({
    declarations: [
        BsModalConfirmComponent,
        BsModalAlertComponent
    ],
    imports: [
        ModalModule.forRoot(),
        FormsModule
    ],
    providers: []
})
export class ModalCustomDialogsModule {}
